import Model from '@/models/BaseModel'
import i18n from '@/plugins/i18n'

export default class Module extends Model {
    resourceName() {
        return 'modules'
    }

    fields() {
        return [
            'id',
            'external_id',
            'name',
            'type',
            'original_price',
            'partner_price',
            'whitelabel_price',
            'price_type',
            'included',
            'charge_from',
            'fixed',
            'partner',
            'whitelabel',
            'activate',
            'enable_by',
            'update_on_plans',
            'plan',
            'third_party',
        ]
    }

    get formattedOriginalPrice() {
        return i18n.n(this.original_price, 'currency')
    }

    get formattedPartnerPrice() {
        return i18n.n(this.partner_price, 'currency')
    }

    get formattedWhitelabelPrice() {
        return i18n.n(this.whitelabel_price, 'currency')
    }

    get searchable() {
        return ['name']
    }

    get tableColumns() {
        return [
            { text: i18n.t('modules.index.table.headers.name'), value: 'name' },
            {
                text: i18n.t('modules.index.table.headers.original-price'),
                value: 'original_price',
                width: 150,
            },
            {
                text: i18n.t('modules.index.table.headers.partner-price'),
                value: 'partner_price',
                width: 250,
            },
            {
                text: i18n.t('modules.index.table.headers.whitelabel-price'),
                value: 'whitelabel_price',
                width: 250,
            },
            {
                text: i18n.t('resellers.types.partner'),
                value: 'partner',
                width: 250,
            },
            {
                text: i18n.t('resellers.types.whitelabel'),
                value: 'whitelabel',
                width: 250,
            },
            {
                text: i18n.t('tables.actions'),
                value: 'action',
                sortable: false,
                width: 150,
                align: 'end',
            },
        ]
    }
}
